/*
 * @providesModule SKAdNetworkController
 *
 */

const SKAdNetworkController = {
  triggerAdNetworkConversion: (type: string, value: string | null = null) => {
    console.log('WebSDK: SKAdNetworkController.triggerAdNetworkConversion() MOCK USED', {
      type,
      value,
    });
  },
};

export default SKAdNetworkController;
